import React, { PureComponent } from 'react';
import { View, SectionList, StyleSheet } from 'react-native';
import { DRNTextInputHeader } from '@traveloka/district-ui';

import R from 'common/res/R';

import BusAutoCompleteStationSectionHeader from '../BusAutoCompleteStationSectionHeader/BusAutoCompleteStationSectionHeader';
import BusAutoCompleteStationItem from '../../containers/BusAutoCompleteStationItemContainer';

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: R.color.uiLightPrimary,
  },
});

class BusAutoCompleteStation extends PureComponent {
  renderSectionHeader = ({ section }) => (
    <BusAutoCompleteStationSectionHeader
      key={section.label}
      title={section.label}
    />
  );

  renderItem = ({ item, section }) => (
    <BusAutoCompleteStationItem
      key={`${section.label}-${item}`}
      item={item}
      onPress={this.props.onItemPressed}
    />
  );

  extractKey = item => item;

  render() {
    const {
      sections,
      onChangeKeyword: handleChangeKeyword,
      onClose: handleClose,
      value,
    } = this.props;

    return (
      <View style={styles.container}>
        <DRNTextInputHeader
          autoFocus
          placeholder="Ketik kota, terminal, atau agen"
          onChangeText={handleChangeKeyword}
          onClose={handleClose}
          backgroundColor={R.color.brand}
          closeText="Tutup"
          value={value}
        />
        <SectionList
          keyExtractor={this.extractKey}
          sections={sections}
          renderSectionHeader={this.renderSectionHeader}
          renderItem={this.renderItem}
        />
      </View>
    );
  }
}

export default BusAutoCompleteStation;
